import { render } from "./selectableItem.vue?vue&type=template&id=b3f5e484&scoped=true"
import script from "./selectableItem.vue?vue&type=script&lang=js"
export * from "./selectableItem.vue?vue&type=script&lang=js"

import "./selectableItem.vue?vue&type=style&index=0&id=b3f5e484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f5e484"]])

export default __exports__